// extracted by mini-css-extract-plugin
export default {"Gallery":"Gallery_Gallery__isN+C"};